import { useCallback } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useDocumentTitle } from "~/hooks/useDocumentTitle";
import { getSharedConversation } from "~/services/shares";
import { ReadOnlyConversationView } from "./ReadOnlyConversationView";

export const SharedConversationRoute = () => {
  const { token } = useParams<{ token: string }>();

  if (!token) return null;

  return <SharedConversation key={token} token={token} />;
};

interface SharedConversationProps {
  token: string;
}

const SharedConversation = ({ token }: SharedConversationProps) => {
  const { state } = useLocation();
  useDocumentTitle("Shared Conversation");
  // Set when launched from an agent's featured sessions, to frame the banner.
  const agentDisplayName: string | undefined = state?.agentDisplayName;

  const fetcher = useCallback(
    (signal: AbortSignal) => getSharedConversation(token, { signal }),
    [token]
  );

  const featured = Boolean(agentDisplayName);

  return (
    <ReadOnlyConversationView
      conversationId={null}
      shareToken={token}
      fetcher={fetcher}
      bannerSubtitleContent={
        agentDisplayName ? `Featured session from ${agentDisplayName} · Read-only.` : undefined
      }
      ownerVerb="Shared by"
      notFoundTitle={
        featured
          ? "This featured session isn't available"
          : "This shared conversation isn't available"
      }
      notFoundBody="The link may have been revoked, or it never existed."
      readOnlyFeedback
    />
  );
};
